const KEY = 'simplicateSignupTour'

export function getTour() {
    try {
        return JSON.parse(window.localStorage.getItem(KEY))
    } catch {
        return null
    }
}

export function saveTour(patch) {
    try {
        const state = Object.assign(getTour() || {}, patch)
        window.localStorage.setItem(KEY, JSON.stringify(state))
    } catch {
        // Ignore storage failures (private mode, quota, etc.).
    }
}

export function clearTour() {
    try {
        window.localStorage.removeItem(KEY)
    } catch {
        // Ignore storage failures.
    }
}
